import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const tumblr: Platform = {
  id: 'tumblr',
  name: 'Tumblr',
  iconIndex: PlatformRegistry.tumblr.index,
  color: PlatformRegistry.tumblr.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.tumblr.com/widgets/share/tool/preview', {
      shareSource: 'legacy',
      canonicalUrl: '',
      url: content.url,
      title: content.title,
    });
  },
};

